import { PaywallDisplay } from 'redux/slices/paywall'
import React from 'react'

import RedeemCode from 'components/set/RedeemCode/RedeemCode'
import { PaywallContainer } from 'components/common/PaywallContainer/PaywallContainer'

const PaywallCodeRedemption: React.FC = () => {
    return (
        <PaywallContainer goBackStep={PaywallDisplay.PROMPT}>
            <RedeemCode />
        </PaywallContainer>
    )
}

export default PaywallCodeRedemption
